<template>
  <el-dialog
    id="edit-modal"
    class="form-modal"
    :visible.sync="editVisible"
    v-loading="editProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="edit-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">View / Edit Global Feature Codes</h1>
        <div class="modal-actions col-2">
<!--          <el-button type="primary" @click="editOperation" :disabled="true">Save</el-button>-->
          <el-button type="default" @click="cancelOperation">Cancel</el-button>
        </div>
      </div>
    </div>

    <el-form>
      <recent-audits
			service="Feature Code" :record="selectedFeature" />
      <div class="inline-form-group">
        <el-col :span="13">
          <el-input v-model="code" placeholder="Code">
            <template slot="prefix">Code</template>
            <template v-if="codeInUse" slot="append">In Use!</template>
          </el-input>
        </el-col>
        <el-col :span="1" />
        <el-col :span="10">
          <el-select v-model="numvar" placeholder="Variable" clearable>
            <el-option
              v-for="(numVar, idx) in numvarOptions"
              :key="idx"
              :value="numVar"
              :label="numVar"
            />
            <template slot="prefix">Variable</template>
          </el-select>
        </el-col>
      </div>
      <div class="inline-form-group">
        <el-tag class="mb-10" type="warning">
          <i class="el-icon-warning" style="margin-right: 4px;"></i>
          Feature code must not match #0, #1, ## &amp; #*
          and must start with either # or *.
        </el-tag>
      </div>

      <el-input v-model="editForm.comment" placeholder="Enter description">
        <template slot="prefix">Description</template>
      </el-input>

      <div class="mt-20">
        <h2 class="form-section-header">When this code is dialed</h2>
        <div class="inline-form-group">
          <el-col :span="24">
            <destination-selector
              :draggable="true"
              :showHeader="false"
              :draggableDestTypes="draggableDestTypes"
              :selectedDestinations="editForm.destinations"
              :clearFields="clearFormFields"
              @destinationsSelected="onDestinationsSelection"
              title=""
            />
          </el-col>
        </div>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import DestinationSelector from "@/components/DestinationSelector.vue";
import RecentAudits from '@/components/RecentAudits';

export default {
  name: "GlobalFeaturesCodeEditForm",

  props: {
    editVisible: { required: true },
    codeInUse: { required: true },
    draggableDestTypes: { required: true },
    clearFormFields: { required: true },
    editProcessing: { required: true },
    selectedFeature: { required: true }
  },

  components: {
    DestinationSelector,
    RecentAudits
  },

  data() {
    return {
      userChangedFeatureCode: false,
      userChangedNumVar: false,
      initialFeatureCode: "",
      numvar: "",
      code: "",
      numvarOptions: ["EXT", "NUM"],
      editForm: {
        tenantId: 0,
        code: "",
        numvar: "",
        comment: "",
        destinations: []
      }
    };
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    },

    selectedFeature(val) {
      const { code, comment, destinations } = val;
      this.editForm.comment = comment;
      this.initialFeatureCode = code;
      const codeArr = code.split("[");
      this.code = codeArr[0];
      if (codeArr.length === 2) {
        this.numvar = codeArr[1].substr(0, codeArr[1].length - 1);
      }

      if (destinations && destinations.length) {
        this.editForm.destinations = [...destinations];
      }
    },

    code(val) {
      this.editForm.code = val;
      if (!this.userChangedFeatureCode) {
        this.userChangedFeatureCode = true;
        return;
      }

      const featureCode = `${val}${this.numvar ? "[" + this.numvar + "]" : ""}`;

      if (featureCode !== this.initialFeatureCode) {
        this.$emit("checkFeatureCode", featureCode);
      } else {
        this.$emit("checkFeatureCode", "*");
      }
    },

    numvar(val) {
      this.editForm.numvar = val;
      if (!this.userChangedNumVar) {
        this.userChangedNumVar = true;
        return;
      }

      const featureCode = `${this.code}[${val}]`;

      if (featureCode !== this.initialFeatureCode) {
        this.$emit("checkFeatureCode", featureCode);
      } else {
        this.$emit("checkFeatureCode", "*");
      }
    }
  },

  methods: {
    onDestinationsSelection(destinations) {
      this.editForm.destinations = [...destinations];
    },

    editOperation() {
      const editBody = { ...this.editForm };

      if (
        editBody.destinations.length > 1 &&
        editBody.destinations.find(dst => !dst.id)
      ) {
        this.$notify({
          title: "Empty Destination field",
          message: "Don't leave any destination field to be empty.",
          type: "error"
        });
        return;
      }

      if (
        editBody.destinations.length === 1 &&
        editBody.destinations[0].id === null
      ) {
        editBody.destinations = [];
      } else {
        editBody.destinations.forEach((dst, idx) => (dst.order = idx + 1));
      }

      this.$emit("editOperation", editBody);
    },

    cancelOperation() {
      this.$emit("cancelOperation", "edit");
    },

    clearFields() {
      this.initialFeatureCode = "";
      this.userChangedFeatureCode = false;
      this.userChangedNumVar = false;
      this.numvar = "";
      this.code = "";

      this.editForm = {
        tenantId: 0,
        code: "",
        comment: "",
        numvar: "",
        destinations: []
      };

      this.$emit("formsCleared");
    },

    remoteMethodForAvailableNums(query) {
      this.$emit("remoteMethodForAvailableNums", query);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variables";

.checkbox-group {
  max-width: 600px;
  margin: auto;
}

.el-tabs {
  max-width: 600px;
  margin: auto;
}

.dashboard-button-group {
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    padding-left: 10px;
  }
}

.dashboard-button {
  text-align: center;
  padding: 18px;
}

.not-in-use {
  background: $voxo-pink;
}

.dnd-icon {
  right: -2px;
}

.el-tab-pane .inline-form-group .el-col .el-select {
  margin: 5px auto;
}
</style>
